'use client'

import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { queryClient } from '../lib/queryClient'
import ThemeProvider from './ThemeProvider'
import { AuthProvider } from '../contexts/AuthContext'
import { CategoriesProvider } from '../contexts/CategoriesContext'

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider>
          <CategoriesProvider>
            {children}
          </CategoriesProvider>
        </AuthProvider>
      </ThemeProvider>
      
      {/* DevTools - only shows in development */}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}

